export const getActionVariant = (action: string) => {
  switch (action) {
    case "create":
      return "success";
    case "update":
      return "dilemma_archived";
    case "delete":
      return "primary_light";
    case "access":
      return "dilemma_scheduled";
    default:
      return "secondary";
  }
};

// For nested objects, only these sub-keys are shown per parent key
const NESTED_ALLOWED_KEYS: Record<string, Set<string>> = {
  uploaded_files: new Set(["uploaded_file"]),
};

const HIDDEN_KEYS = new Set([
  "id",
  "created_at",
  "updated_at",
  "sequence_number",
  "object_pk",
  "content_type",
  "file_size",
  "uploaded_file",
]);

export interface ParsedChange {
  key: string;
  oldValue: string;
  newValue: string;
}

export function parseChanges(
  changes: Record<string, [string, string] | Record<string, [string, string]>>,
): ParsedChange[] {
  const result: ParsedChange[] = [];
  for (const [key, value] of Object.entries(changes)) {
    if (HIDDEN_KEYS.has(key)) continue;
    if (Array.isArray(value)) {
      const [oldValue, newValue] = value;
      if (oldValue?.startsWith("main.") || newValue?.startsWith("main."))
        continue;
      result.push({ key, oldValue, newValue });
    } else {
      const allowedSubKeys = NESTED_ALLOWED_KEYS[key];
      for (const [subKey, [oldValue, newValue]] of Object.entries(value)) {
        if (allowedSubKeys && !allowedSubKeys.has(subKey)) continue;
        if (oldValue?.startsWith("main.") || newValue?.startsWith("main."))
          continue;
        result.push({ key: `${key}.${subKey}`, oldValue, newValue });
      }
    }
  }
  return result;
}
